module.exports = __webpack_public_path__ + "bf476e6a2e03776b87ce7347a755d0f5.png";